import E001 from './E001';
import ProviderCampaign from './ProviderCampaign';
import MenuAdvertisement from './MenuAdvertisement';

export default {
  E001,
  E002: E001,
  E003: E001,
  E004: E001,
  E005: E001,
  E006: E001,
  providerCampaign: ProviderCampaign,
  menuAdvertisement: MenuAdvertisement,
};
